/* eslint-disable @typescript-eslint/no-explicit-any */
import Icon from '@mercadoni/sinister/dist/cjs/Icon'
import { useGroupedPages } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import { GroupedPage } from '@mercadoni/sinister/dist/lib/src/entities/groupedPages'
import { Collapse } from 'antd'
import React, { FC } from 'react'
import styled from 'styled-components'
import PageLink from './PageLink'

const { Panel } = Collapse

const PagesCollapseStyles = styled(Collapse)`
  &.ant-collapse {
    padding: 0;
    > .ant-collapse-item {
      box-shadow: none;

      .ant-collapse-content-box {
        background-color: transparent;
        padding-top: 0 !important;
        padding-bottom: 0;
      }

      > .ant-collapse-header {
        padding: 20px;
        margin: 0;
        font-weight: var(--typography-weight-normal);
        color: #616161 /* character/secondary */;
        background-color: transparent;
      }
    }
  }
`

interface PagesCollapseLogicProps {
  Wrapper: any
  groupedPages?: GroupedPage[]
  onCloseDrawer?: () => void
  [key: string]: any
}

const PagesCollapseLogic: FC<PagesCollapseLogicProps> = ({
  Wrapper,
  groupedPages = [],
  ...props
}) => {
  return (
    <Wrapper accordion ghost expandIconPosition="end">
      {groupedPages.map((page) => {
        const { name, key, children, link } = page

        return (
          <React.Fragment key={key}>
            {children?.length ? (
              <Panel header={name} key={String(key)}>
                <PagesCollapseLogic
                  Wrapper={Wrapper}
                  groupedPages={children}
                  expandIcon={<Icon className="ph-caret-right" />}
                  {...props}
                />
              </Panel>
            ) : (
              <PageLink
                text={name || ''}
                {...link}
                path={link?.path || ''}
                {...props}
              />
            )}
          </React.Fragment>
        )
      })}
    </Wrapper>
  )
}

const PagesCollapse = (props: any) => {
  const { groupedPages } = useGroupedPages({
    position: 'header',
  })

  if (!groupedPages.length) {
    return null
  }
  return (
    <PagesCollapseLogic
      Wrapper={PagesCollapseStyles}
      groupedPages={groupedPages}
      {...props}
    />
  )
}

export default PagesCollapse
